import React, { useEffect, useRef } from 'react'
import { LatLong } from './lat-long.type'

type IframeMapProps = {
    coords: LatLong | null
}

const LAT_OFFSET = 0.0005  // ~55m north/south
const LON_OFFSET = 0.0008  // ~45m east/west at 60°N

export const IframeMap: React.FC<IframeMapProps> = ({ coords }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null)

    useEffect(() => {
        if (!coords || !iframeRef.current) return

        const { lat, long } = coords
        if (!lat || !long) return

        const bbox = `${long - LON_OFFSET},${lat - LAT_OFFSET},${long + LON_OFFSET},${lat + LAT_OFFSET}`
        const url = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${long}`

        iframeRef.current.src = url
    }, [coords])

    return (
        <div aria-label="Property map" style={{ width: '100%', height: '100%' }}>
            <iframe
                ref={iframeRef}
                tabIndex={-1}
                style={{ minHeight: '300px', border: 0 }}
                title="propertyMap"
                width="100%"
                height="100%"
                src="about:blank"
            />
        </div>
    )
}
